import React, {useContext, useEffect, useState} from 'react';
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {SHOPIFY_PRODUCT_FIELDS_LIST} from "../../../shopify/constants/shopify.constant";
import ShowProductLink from "../../../shopify/components/product/show-prouct-link";
import ShowProductOptions from "../../../shopify/components/product/show-prouct-options";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import AppContext from "../../../common/context/app-context";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import AddEditImageMedia from "../media-editor/add-edit-image-media";

const SelectedProductList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const appContext = useContext(AppContext);
    let {shopifyDetail, removeShopifyProduct, clearSelectedShopifyProducts} = appContext;

    useEffect(() => {
        if (shopifyDetail) {
            console.log({shopifyDetail});
        }
    }, [initialStep]);


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Selected Products
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-outline-green px-2 py-1"
                            onClick={clearSelectedShopifyProducts}>
                            Clear Selected Products
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-center mt-4">

                <div className="shopify-table-container w-full overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={shopifyDetail?.products}
                        label={'Shopify Products'}/>

                    {shopifyDetail?.products?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{productField?.label}</th>
                                ))}
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Copy</th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Action</th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {shopifyDetail?.products?.map((product, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto">

                                                {productField?.type !== 'list' && productField?.type !== 'object' &&
                                                    <>
                                                        {productField?.attribute === 'id' &&
                                                            <div className="text-center">
                                                                <ShowProductLink product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'options' &&
                                                            <div className="text-center">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute !== 'id' &&
                                                            <>{product[productField?.attribute]}</>
                                                        }
                                                    </>
                                                }

                                                {productField?.type === 'list' &&
                                                    <>
                                                        {productField?.attribute === 'options' &&
                                                            <div className="">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'images' &&
                                                            <div className="text-center">
                                                                <ProductImageSmall
                                                                    imageUrl={product[productField.attribute][0]?.url}/>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="w-20 p-2 border border-gray-400 m-auto text-center">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={`${product?.title}\n${product?.onlineStoreUrl}\n`}/>
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto text-center">
                                        {/*<div className="flex justify-center">
                                            <ShowProductImages
                                                product={product}
                                                selectedDesign={selectedDesign}
                                                setSelectedDesign={setSelectedDesign}
                                                setSelectedProduct={setSelectedProduct}
                                                setProductDetailInList={setProductDetailInList}/>
                                        </div>*/}
                                        <button
                                            className={`py-2 px-4 button-outline-gray mr-2`}
                                            onClick={() => {
                                                removeShopifyProduct(product)
                                            }}>
                                            <span>Remove</span>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default SelectedProductList
